import { Document, DocumentVersion } from "@models";
import { Dispatch, ReactNode, SetStateAction } from "react";
import { TiptapApproversTab } from "src/components/TiptapEditor/TiptapApproversTab";

export const ApproversTab = ({
  actions,
  selectedDocVersion,
  deviceId,
  selectedDoc,
  isEditMode,
  setIsEditMode,
  onBeforeSubmitApproval,
}: {
  actions?: ReactNode;
  selectedDoc: Document;
  selectedDocVersion: DocumentVersion;
  deviceId: string;
  isEditMode: boolean;
  setIsEditMode: Dispatch<SetStateAction<boolean>>;
  onBeforeSubmitApproval?: () => Promise<void>;
}) => {
  return (
    <TiptapApproversTab
      actions={actions}
      deviceId={deviceId}
      selectedDocVersion={selectedDocVersion}
      selectedDoc={selectedDoc}
      isEditMode={isEditMode}
      setIsEditMode={setIsEditMode}
      onBeforeSubmitApproval={onBeforeSubmitApproval}
    />
  );
};

export default ApproversTab;
